export const constants = {
  noDataFoundMessage: "No data available"
};

export const reportTypes = [
  {
    label: "User Database (Users with valid email address)",
    value: "User Database"
  },
  {
    label: "All User Database",
    value: "All User Database"
  }
];

export const UserLocations = [
  { value: "onload", name: "onload" },
  { value: "ribbons", name: "ribbons" },
  { value: "prepaid", name: "prepaid" },
  { value: "shop", name: "shop" },
  { value: "survey", name: "survey" },
  { value: "rewardlepay", name: "rewardlepay" }
];
